module.exports = __webpack_public_path__ + "img/ico_arr_right.4d3b638e.svg";